import { Routes } from '@angular/router';
import { ErrorPageRouterComponent } from '@modules/error-page/error-page.router';
import { RouterComponent } from 'common';

export const AppRoutes: Routes = [
  {
    path: 'error',
    component: ErrorPageRouterComponent,
    loadChildren: () => import('@interticket/core').then(m => m.ErrorPageModule),
  },
  {
    path: '',
    component: RouterComponent,
    loadChildren: () => import('@public-site/app-skeleton/app-skeleton.module').then(m => m.AppSkeletonModule),
  },
  {
    path: '**',
    component: ErrorPageRouterComponent,
    loadChildren: () => import('@interticket/core').then(m => m.ErrorPageModule),
  },
];
